const userRegisterForm = document.querySelector('.user-register-form');

if (userRegisterForm) {
  const jsDate = userRegisterForm.querySelector('.js-form-type-date')
  const inputDate = userRegisterForm.querySelector('.js-form-type-date input.form-date')
  const submitButton = userRegisterForm.querySelector('#edit-submit');
  const minAge = 18;

  jQuery(".user-register-form #edit-field-cellphone").keyup(function(){
    var cellphone = jQuery(this).val();
    if (cellphone.charAt(0) === '0') {
      jQuery(this).val('27');
    }
    if(cellphone.charAt(2) === '0') {
      jQuery(this).val('27');
    }
    jQuery(this).val(jQuery(this).val().replace(/\s/g, ''));
  });

  const ageValidation = () => {
    const inputValue = inputDate.value;
    const userDate = new Date(inputValue);
    const userYear = userDate.getFullYear();
    const userAge = new Date(Date.now() - userDate.getTime()).getUTCFullYear() - 1970;
    const labelError = userRegisterForm.querySelector('.js-form-type-date label.error')
  
    if ( userAge < minAge ) {
      inputDate.parentNode.classList.add('error')
      submitButton.disabled = true
      if (!labelError) {
        jsDate.insertAdjacentHTML('beforeend', '<label class="error">You must be over 18 to register</label>')
      }
    } else {
      inputDate.parentNode.classList.remove('error')
      if (labelError) {
        labelError.remove()
      }
      submitButton.disabled = false
    }
    if (userYear.toString().length !== 4) {
      if (labelError) {
        labelError.remove()
      }
    }
  }

  inputDate.addEventListener('input', () => {
    ageValidation()
  });

  const inputName = userRegisterForm.querySelector('.field--name-field-name input.form-control')
  
  inputName.addEventListener('input', () => {

    const labelErrorN = userRegisterForm.querySelector('.field--name-field-name label.error-character')

    let textName = inputName.value
    let onlyTextN = textName.replace(/[0-9]/g, '');
    inputName.value = onlyTextN
    if( textName.length < 3 && textName.length > 0) {
      inputName.classList.add('error')
      if (!labelErrorN) {
        inputName.insertAdjacentHTML('afterend', '<label class="error-character">The Name must have more than 2 characters.</label>')
      }
    } else {
      inputName.classList.remove('error-character')
      if (labelErrorN) {
        labelErrorN.remove()
      }
    }
  });

  const inputSurname = userRegisterForm.querySelector('.field--name-field-surname input.form-control')
  
  inputSurname.addEventListener('input', () => {

    const labelErrorS = userRegisterForm.querySelector('.field--name-field-surname label.error-character')

    let textSurname = inputSurname.value
    let onlyTextS = textSurname.replace(/[0-9]/g, '');
    inputSurname.value = onlyTextS
    if( textSurname.length < 3 && textSurname.length > 0) {
      inputSurname.classList.add('error')
      if (!labelErrorS) {
        inputSurname.insertAdjacentHTML('afterend', '<label class="error-character">The Surname must have more than 2 characters.</label>')
      }
    } else {
      inputSurname.classList.remove('error-character')
      if (labelErrorS) {
        labelErrorS.remove()
      }
    }
  });



}



// WEBPACK FOOTER //
// ./js/components/otp/_otp--user-register-form.js